'use strict';

/*global app*/
/*global services*/
/*global normalizeInput*/
/*global invokeCallback*/
/*global wrrSuccess*/

function PackingPlaceService() {
  this.modal = null;
  this.data = null;

  this.init();
}

PackingPlaceService.prototype = $.extend({}, {
  constructor: 'PackingPlaceService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.packing-place-service__select', function () {
      _this.doSelectPackingPlace($(this).data('packing_place_id'));
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  doSelectPackingPlace: function doSelectPackingPlace(packingPlaceId) {
    var _this = this;

    _this.modal.close(function () {
      _this.data.callback(packingPlaceId);
    });

    return _this;
  },

  selectPackingPlace: function selectPackingPlace(data, callback) {
    var _this = this;

    data = normalizeInput(data);
    data.callback = callback;

    _this.data = data;
    _this.modal.open({
      modalClass: 'packing-place-service',
      title: data.title || app.t('packing.choose_place'),
      height: 'auto',
      width: 'md',
      form: false
    }).block();

    $.get(app.path('packing_select_place'), { area: data.area }, function (res) {
      _this.modal.unBlock();
      _this.modal.content(res.data.html);

      var $packingPlaces = _this.modal.contentDOM().find('.packing-place-service__select');
      if ($packingPlaces.length === 1) {
        _this.doSelectPackingPlace($packingPlaces.data('packing_place_id'));
      }
    });

    return _this;
  },

  doScanPackingPlace: function doScanPackingPlace(data, value) {
    var _this = this;

    $.get(app.path('packing_find_place', { area: data.area, abbr: value }), function (res) {
      if (res.msg === 'SUCCESS') {
        _this.data.callback(res.data.id);
      } else {
        _this.scanPackingPlace(_this.data, _this.data.callback);
      }
    });

    return _this;
  },

  scanPackingPlace: function scanPackingPlace(data, callback) {
    var _this = this;

    data = normalizeInput(data);
    data.title = data.title || app.t('packing.scan_place');
    data.callback = callback;

    _this.data = data;

    app.getValue({ title: _this.data.title, content: _this.data.content }, function (value) {
      _this.doScanPackingPlace(data, value);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  addPackingPlace: function addPackingPlace(params) {
    var _this = this;

    params = params || {};
    params.packingPlaceId = params.packingPlaceId || 0;

    if (params.packingPlaceId === 0) {
      //musime nacist umisteni na baleni - pouze pokud je vyzadovano
      if ($.inArray(params.area, app.param('scanned_areas')) >= 0) {
        _this.scanPackingPlace({ area: params.area, title: app.t('packing.scan_packing_place') }, function (packingPlaceId) {
          params.packingPlaceId = packingPlaceId;

          _this.savePackingPlace(params);
        });
      } else {
        _this.selectPackingPlace({ area: params.area }, function (packingPlaceId) {
          params.packingPlaceId = packingPlaceId;

          _this.savePackingPlace(params);
        });
      }
    } else {
      invokeCallback(params.callback);
    }

    return _this;
  },

  savePackingPlace: function savePackingPlace(params) {
    var _this = this;

    var data = {
      WebDocumentRID: params.webDocumentRID,
      JoiningSymbol: params.joiningSymbol,
      HandlingUnit: params.handlingUnit,
      Status: params.status,
      PackingPlaceId: params.packingPlaceId
    };

    app.getFormation('packing:save_packing_area', data, function (res) {
      if (res.msg === 'SUCCESS' && res.data.Result === wrrSuccess) {
        invokeCallback(params.callback);
      } else {
        params.packingPlaceId = 0;

        _this.addPackingPlace(params);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-input');

    _this.registerCallbacks();

    return _this;
  }
});
